import { render, staticRenderFns } from "./play-quiz.vue?vue&type=template&id=51deaa2c&"
import script from "./play-quiz.vue?vue&type=script&lang=js&"
export * from "./play-quiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports